import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const META_PIXEL_ID = '1258557583050525'

export function useMetaPixel() {
  useEffect(() => {
    // Avoid re-initializing
    if (window.fbq) return

    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    window.fbq('init', META_PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}

let initiateCheckoutFired = false

export function trackInitiateCheckout(): Promise<void> {
  return new Promise((resolve) => {
    if (window.fbq && !initiateCheckoutFired) {
      initiateCheckoutFired = true
      window.fbq('track', 'InitiateCheckout')
      setTimeout(resolve, 300)
    } else {
      resolve()
    }
  })
}
